import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Hook to scroll to the top of the page when the route changes
 * Useful for HashRouter and BrowserRouter implementations
 */
export const useScrollToTop = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top smoothly
    globalThis.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [location.pathname]);
};

export default useScrollToTop;
